/**
 * CSP-Friendly replacement for _.template
 * Does not use vulnerable new Function()
 */

declare function require(...params);

const defaults = require('../../../node_modules/underscore/cjs/defaults.js');
const underscore = require('../../../node_modules/underscore/cjs/underscore.js');
require('../../../node_modules/underscore/cjs/templateSettings.js');

var noMatch = /(.)^/;
var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
};
var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

function escapeChar(match) {
    return '\\' + escapes[match];
}

var bareIdentifier = /^\s*(\w|\$)+\s*$/;

export function safeTemplate(text, nonce, settings?, oldSettings?) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = defaults({}, settings, underscore.templateSettings);

    var matcher = RegExp(
        [
            (settings.escape || noMatch).source,
            (settings.interpolate || noMatch).source,
            (settings.evaluate || noMatch).source
        ].join('|') + '|$',
        'g'
    );

    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
        index = offset + match.length;

        if (escape) {
            source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        } else if (interpolate) {
            source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        } else if (evaluate) {
            source += "';\n" + evaluate + "\n__p+='";
        }
        return match;
    });
    source += "';\n";

    var argument = settings.variable;
    if (argument) {
        if (!bareIdentifier.test(argument)) throw new Error('variable is not a bare identifier: ' + argument);
    } else {
        source = 'with(obj||{}){\n' + source + '}\n';
        argument = 'obj';
    }

    source =
        "var __t,__p='',__j=Array.prototype.join," +
        "print=function(){__p+=__j.call(arguments,'');};\n" +
        source +
        'return __p;\n';

    var render;
    try {
        // Safe alternative to new Function
        if (typeof document !== 'undefined') {
            // Browser environment
            var script = document.createElement('script');
            script.nonce = nonce;
            script.text = 'window.__tempRender = function(' + argument + ',_){' + source + '}';
            document.head.appendChild(script);
            render = (window as any).__tempRender;
            document.head.removeChild(script);
            delete (window as any).__tempRender;
        } else {
            // Node.js environment
        }
    } catch (e) {
        e.source = source;
        throw e;
    }

    var template: any = function (data) {
        return render.call(this, data, underscore);
    };

    template.source = 'function(' + argument + '){\n' + source + '}';
    return template;
}

